import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { InstallPermissionAccessTypes } from '../../constants/installPermissions';
import { useApp } from '../../contexts/AppContext';
import { useInstallPermissions } from '../../contexts/InstallPermissionsContext';
import { useInstallPermissionsDowngrade } from '../../contexts/InstallPermissionsDowngradeContext';
import { useTeamsGate } from '../../contexts/TeamsGateContext';
import { jsx as _jsx } from "react/jsx-runtime";
function getPermissionSettingName(state, isUngatedForTeamsGate) {
  let messageKey;
  switch (state) {
    case InstallPermissionAccessTypes.EVERYONE:
      messageKey = 'app-governance-lib.installPermissions.permissionSettingNames.EVERYONE';
      break;
    case InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS:
      messageKey = 'app-governance-lib.installPermissions.permissionSettingNames.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS';
      break;
    case InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS:
      messageKey = isUngatedForTeamsGate ? 'app-governance-lib.installPermissions.permissionSettingNames.SPECIFIC_USERS_AND_TEAMS_WITH_TEAMS' : 'app-governance-lib.installPermissions.permissionSettingNames.SPECIFIC_USERS_AND_TEAMS';
      break;
    default:
      messageKey = 'app-governance-lib.installPermissions.permissionSettingNames.EVERYONE';
  }
  return I18n.text(messageKey);
}
export function InstallPermissionsDowngradeAlert() {
  const {
    appName
  } = useApp();
  const {
    installPermissionAccessState,
    initialInstallPermissionAccessState
  } = useInstallPermissions();
  const {
    showAlert,
    impactedUserCount
  } = useInstallPermissionsDowngrade();
  const isUngatedForTeamsGate = useTeamsGate();
  if (!showAlert) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installPermissions.downgradeConfirmation.title",
      options: {
        appName
      }
    }),
    marginBlockEnd: "400",
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "app-governance-lib.installPermissions.downgradeConfirmation.description",
      options: {
        currentSetting: getPermissionSettingName(initialInstallPermissionAccessState, isUngatedForTeamsGate),
        newSetting: getPermissionSettingName(installPermissionAccessState, isUngatedForTeamsGate),
        appName,
        count: impactedUserCount
      }
    })
  });
}